/**
 * Les dates de la fiche SAV du distributeur.
 *
 * `formaterDateAjout` (R5, lot L1) dit QUAND une photo a ete ajoutee, a l'heure de Paris
 * quel que soit le fuseau du navigateur : un depanneur en deplacement, ou un poste regle
 * en UTC, doit lire la meme heure que le poseur qui a pris la photo. La date qui fait foi
 * est celle de l'AJOUT dans CFTSign ou Flexcore (decision de Boubacar du 26/10), jamais
 * l'EXIF ni la date du chantier : sans date lisible, on le dit, on n'invente rien.
 */

const FUSEAU_DE_REFERENCE = 'Europe/Paris';

const FORMAT_AJOUT = new Intl.DateTimeFormat('fr-FR', {
  timeZone: FUSEAU_DE_REFERENCE,
  day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

export const DATE_AJOUT_INCONNUE = "Date d'ajout inconnue";

/** « Ajoutée le JJ/MM/AAAA à HH:MM » (heure de Paris), ou « Date d'ajout inconnue ». */
export function formaterDateAjout(valeur) {
  if (typeof valeur !== 'string' || !valeur.trim()) return DATE_AJOUT_INCONNUE;
  const instant = new Date(valeur);
  if (Number.isNaN(instant.getTime())) return DATE_AJOUT_INCONNUE;
  // Par morceaux plutot que par `format()` : la ponctuation entre date et heure varie
  // selon la version d'ICU (« , » ou « à »), les morceaux non.
  const m = Object.fromEntries(FORMAT_AJOUT.formatToParts(instant).map((p) => [p.type, p.value]));
  return `Ajoutée le ${m.day}/${m.month}/${m.year} à ${m.hour}:${m.minute}`;
}

/** Date et heure d'une interaction, a la francaise (heure du navigateur, comme avant). */
export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
  catch { return iso; }
};

/** Date courte (pose d'un equipement). */
export const fmtDateShort = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return iso; }
};
